window.addEventListener('SITE_START', () => {
  const $section = document.querySelector('#homeGroupBusiness');
  if (!$section) return;
  ScrollTrigger.create({
    trigger: '#homeGroupBusiness .group-business--desktop',
    start: 'top bottom',
    end: 'top top',
    onUpdate: (self) => {
      const progress = self.progress;
      gsap.set('#homeGroupBusiness .group-business--desktop .__bg img', {
        yPercent: (1 - progress) * -60,
      });
    },
  });
  ScrollTrigger.create({
    trigger: '#homeGroupBusiness .group-business--desktop',
    start: 'bottom bottom',
    end: 'bottom top',
    onUpdate: (self) => {
      const progress = self.progress;
      gsap.set('#homeGroupBusiness .group-business--desktop .__bg img', {
        yPercent: progress * 60,
      });
    },
  });

  const timer = {
    per: 0,
  };

  const TIMER_DURATION = 5;
  const $groupBusiness = document.querySelector('#homeGroupBusiness .group-business--desktop');
  const $groups = $groupBusiness.querySelectorAll('.__group');
  const $bgs = $groupBusiness.querySelectorAll('.__bg');
  const $businessItem = $groupBusiness.querySelectorAll('.__business a');

  const showGroup = (group) => {
    const dataIndex = group.getAttribute('data-index');
    const dataTimerDuration = group.getAttribute('data-timer-duration') || '0';

    $groups.forEach((item) => {
      item.classList.toggle('--active', item === group);
    });
    $bgs.forEach((bg) => {
      const bgIndex = bg.getAttribute('data-index');
      bg.classList.toggle('--active', bgIndex === dataIndex);
    });

    gsap.killTweensOf(timer);
    gsap.fromTo(
      timer,
      {
        per: 0,
      },
      {
        per: 100,
        duration: TIMER_DURATION + Number(dataTimerDuration),
        ease: Linear.easeNone,
        onUpdate: () => {
          group.style.setProperty('--g-progress', timer.per + '%');
        },
        onComplete: () => {
          const nextGroup = group.nextElementSibling || $groups[0];
          showGroup(nextGroup);
        },
      }
    );
  };
  const scrollTop = () => {
    if (window.lenis) {
      window.lenis.scrollTo($groupBusiness, {
        dutation: 1,
        lock: true,
        onComplete: () => {
          ScrollTrigger.refresh();
          document.querySelector('#header').classList.add('--hide');
        },
      });
    } else {
      gsap.to(window, {
        scrollTo: $groupBusiness,
        duration: 1,
        ease: Quart.easeOut,
        onComplete: () => {
          ScrollTrigger.refresh();
          document.querySelector('#header').classList.add('--hide');
        },
      });
    }
  };
  $groups.forEach((group) => {
    group.addEventListener('click', () => {
      scrollTop();
      showGroup(group);
    });
  });

  ScrollTrigger.create({
    trigger: '#homeGroupBusiness .group-business--desktop',
    start: 'top bottom',
    end: 'bottom top',
    onEnter: () => {
      showGroup($groups[0]);
    },
    onEnterBack: () => {
      showGroup($groups[0]);
    },
  });
  $businessItem.forEach((item, index) => {
    const dataBg = item.getAttribute('data-bg');
    if (dataBg) {
      item.addEventListener('mouseenter', () => {
        $bgs.forEach((bg) => {
          const bgIndex = bg.getAttribute('data-index');
          bg.classList.toggle('--active', bgIndex === dataBg);
        });
      });
    }
  });

  $groupBusiness.addEventListener('mousewheel', (e) => {
    const dir = e.deltaY > 0 ? 1 : -1;
    if (dir > 0) {
      const groupBusinessRect = $groupBusiness.getBoundingClientRect();
      if (groupBusinessRect.top < 2) return;
      if (groupBusinessRect.top < window.innerHeight * 0.5) {
        scrollTop();
      }
    }
  });

  const swiper = new Swiper('#homeGroupBusiness .swiper', {
    parallax: true,
    speed: 600,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '#homeGroupBusiness .__pagination',
    },
    preventClicks: false,
    preventClicksPropagation: false,
    slideToClickedSlide: false,
    touchStartPreventDefault: false,
  });

  ScrollTrigger.create({
    trigger: '#homeGroupBusiness .group-business--mobile',
    start: 'top bottom',
    end: 'top top',
    onUpdate: (self) => {
      const progress = self.progress;
      gsap.set('#homeGroupBusiness .group-business--mobile .__bg', {
        yPercent: (1 - progress) * -60,
      });
    },
  });

  ScrollTrigger.create({
    trigger: '#homeGroupBusiness .group-business--mobile',
    start: 'bottom bottom',
    end: 'bottom top',
    onUpdate: (self) => {
      const progress = self.progress;
      gsap.set('#homeGroupBusiness .group-business--mobile .__bg', {
        yPercent: progress * 60,
      });
    },
  });
});
